const DeploymentConfigSectionCheckedState = {
  UNCHECKED: "UNCHECKED",
  CHECKED: "CHECKED",
  PROPOSED_CHECKED: "PROPOSED_CHECKED"
}

export default DeploymentConfigSectionCheckedState;